import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e6e04240"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-lg font-semibold text-gray-400" }
const _hoisted_2 = { class: "overflow-auto max-h-[50vh]" }

import { nextTick, reactive } from "vue";
import { onBeforeMount, onMounted, onUnmounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingModal',
  props: {
  visible: Boolean,
  title: {
    type: String,
    default: "Détails",
  },
  position: {
    type: Object as () => { top: number; left: number },
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;
const typeAnimate = ref("animate__zoomIn");
const emit = __emit;
const modalRef = ref<HTMLElement | null>(null);

const dragging = ref(false); // Indique si on est en train de drag
const offset = reactive({ x: 0, y: 0 }); // Décalage souris/modale au moment du click
const modalPosition = ref({ top: props.position.top, left: props.position.left }); // Position dynamique

watch(() => props.visible, async (newVal) => {
  if (newVal) {
    await nextTick(); // On attend le DOM rendu
    modalPosition.value.top = props.position.top;
    modalPosition.value.left = props.position.left;
  }
});

watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      typeAnimate.value = "animate__zoomIn";
    } else {
      typeAnimate.value = "animate__zoomOut";
    }
  },
  { immediate: true }
);

function close() {
  typeAnimate.value = "animate__zoomOut";
  emit("close");
}

function onMouseDown(e: MouseEvent) {
  if (!modalRef.value) return;
  dragging.value = true;
  const rect = modalRef.value.getBoundingClientRect();
  offset.x = e.clientX - rect.left;
  offset.y = e.clientY - rect.top;
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
}

function onMouseMove(e: MouseEvent) {
  if (!dragging.value) return;
  modalPosition.value.left = e.clientX - offset.x;
  modalPosition.value.top = e.clientY - offset.y;
}

function onMouseUp() {
  dragging.value = false;
  document.removeEventListener("mousemove", onMouseMove);
  document.removeEventListener("mouseup", onMouseUp);
}

function handleClickOutside(event: MouseEvent) {
  const modalEl = modalRef.value;
  if (modalEl && !modalEl.contains(event.target as Node)) {
    close(); // Ferme le modal si le clic est à l'extérieur
  }
}

onMounted(() => {
  document.addEventListener("mousedown", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("mousedown", handleClickOutside);
});


return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([typeAnimate.value, { 'fixed z-50 pb-8 px-8 transition-all shadow-xl floating-bg-opacity-100 rounded-lg duration-100 ease-linear animate__animated  animate__faster_xx ': true }]),
        style: _normalizeStyle({
      top: `${modalPosition.value.top}px`,
      left: `${modalPosition.value.left}px`,
      minWidth: '300px',
      maxWidth: '90vw',
      cursor: dragging.value ? 'grabbing' : 'default',
    }),
        ref_key: "modalRef",
        ref: modalRef
      }, [
        _createElementVNode("div", {
          class: "flex items-center justify-between py-8 pb-2 mb-2 mb-4 border-b border-gray-500 cursor-move",
          onMousedown: onMouseDown
        }, [
          _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.title), 1),
          _createElementVNode("button", {
            onClick: close,
            class: "ml-8 text-xl text-gray-400 hover:text-gray-200"
          }, "×")
        ], 32),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 6))
    : _createCommentVNode("", true)
}
}

})